import useIsMobile from '@/hooks/use-is-mobile';
import { Button, ButtonProps, IconEdit } from '@cmpsr/components';

export default function EditAnswerButton({ onClick }: ButtonProps) {
  const isMobile = useIsMobile();
  const size = isMobile ? 'm' : 's';

  return (
    <Button aria-label="Edit answer" onClick={onClick} variant="link-secondary" size={size} trailingIcon={<IconEdit />}>
      {!isMobile ? 'Edit' : ''}
    </Button>
  );
}
